/**
 * Fixed atmosphere behind every page: a masked grid, three drifting blooms, a
 * grain layer and a vignette.
 *
 * Static markup driven entirely by CSS so it costs nothing on the main thread
 * and needs no cleanup. Purely decorative, so it is hidden from assistive tech.
 */
export function Backdrop() {
  return (
    <div className="backdrop" aria-hidden="true">
      <div className="backdrop__grid" />
      <div className="backdrop__bloom backdrop__bloom--a" />
      <div className="backdrop__bloom backdrop__bloom--b" />
      <div className="backdrop__bloom backdrop__bloom--c" />
      <div className="backdrop__vignette" />
      <div className="backdrop__grain" />
    </div>
  );
}
